import { withHandlers } from 'coact/recompose'

import createEffectAction from 'coact/pages/modules/pageAction/createEffectAction'

import View from './PageForm.jsx'

const PageForm = withHandlers({
  setPrice:
    ({ dispatch }) =>
    () => {
      dispatch(createEffectAction({ run: 'every', name: 'countPrice' }))
    },
})(View)

export default PageForm
